/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { InfoBarContext } from "../../../../../common/info";
import { isDesktop } from "../../../../../utils/screenUtil";
import Journal from "../journal/Journal";

function TableRow({ data, setSelectedRow, blur, setTableWidth, rows }) {
  const infoBar = useContext(InfoBarContext);
  const history = useHistory();
  const { t } = useTranslation();
  const status = rows.statusText;
  useEffect(() => {
    if (!infoBar.isOpen) {
      setSelectedRow(null);
      if (isDesktop()) {
        setTableWidth("100%");
      }
    } else {
      if (isDesktop()) {
        setTableWidth("58%");
      }
    }
  });

  const openRequest = () => {
    if (
      status === "Riješeno (Potvrđeno)" ||
      status === "Riješeno (Čeka se potvrda)" ||
      status === "Riješeno (Nije potvrđeno u roku)" ||
      status === "Riješeno (Završen postupak)"
    ) {
      switch (status) {
        case "Riješeno (Potvrđeno)":
          return (
            <a
              onClick={(e) => {
                history.push("/resolvedRequests?uid=" + rows.uid, { linkTab: 0 });
                e.stopPropagation();
              }}
              className={"button"}
            >
              Otvori
            </a>
          );
        case "Riješeno (Čeka se potvrda)":
          return (
            <a
              onClick={(e) => {
                history.push("/resolvedRequests?uid=" + rows.uid, { linkTab: 1 });
                e.stopPropagation();
              }}
              className={"button"}
            >
              Otvori
            </a>
          );
        case "Riješeno (Nije potvrđeno u roku)":
          return (
            <a
              onClick={(e) => {
                history.push("/resolvedRequests?uid=" + rows.uid, { linkTab: 2 });
                e.stopPropagation();
              }}
              className={"button"}
            >
              Otvori
            </a>
          );
        case "Riješeno (Završen postupak)":
          return (
            <a
              onClick={(e) => {
                history.push("/resolvedRequests?uid=" + rows.uid, { linkTab: 3 });
                e.stopPropagation();
              }}
              className={"button"}
            >
              Otvori
            </a>
          );
        default:
          return "Unsupported Action";
      }
    } else if (
      status === "U radu (Zahtjev u obradi)" ||
      status === "U radu (Rješenje u izradi)" ||
      status === "U radu (Tražena dopuna)"
    ) {
      switch (status) {
        case "U radu (Zahtjev u obradi)":
          return (
            <a
              onClick={(e) => {
                history.push("/requirementsInResolving?uid=" + rows.uid, { linkTab: 0 });
                e.stopPropagation();
              }}
              className={"button"}
            >
              Otvori
            </a>
          );
        case "U radu (Rješenje u izradi)":
          return (
            <a
              onClick={(e) => {
                history.push("/requirementsInResolving?uid=" + rows.uid, { linkTab: 2 });
                e.stopPropagation();
              }}
              className={"button"}
            >
              Otvori
            </a>
          );
        case "U radu (Tražena dopuna)":
          return (
            <a
              onClick={(e) => {
                history.push("/requirementsInResolving?uid=" + rows.uid, { linkTab: 1 });
                e.stopPropagation();
              }}
              className={"button"}
            >
              Otvori
            </a>
          );
        default:
          return;
      }
    } else {
      return (
        <a
          onClick={(e) => {
            history.push("/receivedRequests?uid=" + rows.uid);
            e.stopPropagation();
          }}
          className={"button"}
        >
          Otvori
        </a>
      );
    }
  };

  return (
    <tr
      title={t("requests.allRequests.table.tableRow.clickDetails")}
      className={"is-clickable"}
      style={{
        opacity: blur ? 0.2 : 1,
      }}
      onClick={(e) => {
        if (infoBar.isOpen) {
          infoBar.toggle();
        }
        setSelectedRow(rows.uid);
        infoBar.toggle(`${t("requests.allRequests.table.tableRow.requestDetails")}`, () => (
          <Journal uid={rows.uid} id={rows.id} rows={rows} />
        ));
      }}
    >
      {Object.keys(data)
        .filter(
          (key) => !["uid", "receiptDate", "attachments", "letters", "finances"].includes(key)
        )
        .map((key, index) => (
          <td key={"row" + index}>{data[key]}</td>
        ))}
      <td>{openRequest()}</td>
    </tr>
  );
}
export default TableRow;
